import React from "react";
import styled from "styled-components";

export default function({ category, ...rest }) {
  return (
    <Root style={{ backgroundColor: category.color }} {...rest}>
      {category.name}
    </Root>
  );
}

const Root = styled.div`
  display: inline-block;
  line-height: 26px;
  padding: 0 16px;
  color: #3f271e;
  font-weight: bold;
  border-radius: 13px;
  background: #94e7bb;
  font-size: 12px;
`;
